document.addEventListener("DOMContentLoaded", function() {
  console.log("DOM fully loaded and parsed");
  const toggles = document.querySelectorAll('[data-toggle="megamenu"]');
  console.log('Found toggles:', toggles);
 
  toggles.forEach(toggle => {
    const megamenu = toggle.nextElementSibling;
    console.log('Megamenu associated with toggle:', megamenu);
 
    toggle.addEventListener('click', function(event) {
      event.preventDefault();
      console.log('Toggle clicked');
      const isVisible = megamenu.classList.contains('megamenu--visible');
      console.log('Is megamenu visible:', isVisible);
      document.querySelectorAll('.megamenu--visible').forEach(menu => {
        menu.classList.remove('megamenu--visible');
      });
      if (!isVisible) {
        megamenu.classList.add('megamenu--visible');
        console.log('Megamenu is now visible');
      }
    });
 
    megamenu.addEventListener('mouseleave', function() {
      console.log('Mouse left megamenu');
      megamenu.classList.remove('megamenu--visible');
    });
  });
 
  document.addEventListener('click', function(event) {
    toggles.forEach(toggle => {
      const megamenu = toggle.nextElementSibling;
      if (!toggle.contains(event.target) && !megamenu.contains(event.target)) {
        megamenu.classList.remove('megamenu--visible');
        console.log('Clicked outside, megamenu hidden');
      }
    });
  });
});